import React, { useState } from "react";
import { Button } from "reactstrap";
import ChildrenModal from "../../components/modals/ChildrenModal";
import SendRegistrationLink from "./SendRegistrationLink";
import { TemplateVariableProvider } from "../../context/TemplateVariableContext";

const RegistrationLink = ({
	customerEmail = "",
	sendToNumber = "",
	accountID = null,
}) => {
	const [modalOpen, setModalOpen] = useState(false);

	const toggleModal = () => setModalOpen(!modalOpen);

	return (
		<>
			<Button className="btn-md btn-success" onClick={toggleModal}>
				<i className="nc-icon nc-key-25" /> &nbsp;&nbsp;Registration Link
			</Button>

			{modalOpen && (
				<ChildrenModal
					size="lg"
					modal={modalOpen}
					toggle={toggleModal}
					modalTitle="Send Customer Registration Link"
				>
					<TemplateVariableProvider>
						<SendRegistrationLink
							customerEmail={customerEmail}
							sendToNumber={sendToNumber}
							accountID={accountID}
							toggle={toggleModal}
						/>
					</TemplateVariableProvider>
				</ChildrenModal>
			)}
		</>
	);
};

export default RegistrationLink;
